import React, { useState, useEffect } from 'react';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { firestore } from '../lib/firebaseConfig';
import Modal from './Modal';
import Button from './Button';
import FormInput from './FormInput';
import FormLabel from './FormLabel';
import BlockTitle from './BlockTitle';
import './custom-bootstrap.scss';

const EditFlatReminderModal = ({ isOpen, onClose, investmentId }) => {
  const [reminders, setReminders] = useState([
    { days: 7, enabled: true },
    { days: 14, enabled: true },
    { days: 21, enabled: false },
    { days: 30, enabled: true },
  ]);

  useEffect(() => {
    if (investmentId && isOpen) {
      const fetchReminders = async () => {
        // Fetch reminder settings from separate schema
        const remindersRef = doc(firestore, `investment_reminders/${investmentId}`);
        const remindersSnap = await getDoc(remindersRef);
        if (remindersSnap.exists()) {
          const savedReminders = remindersSnap.data().reminders;
          if (savedReminders) {
            setReminders(savedReminders);
          }
        }
      };

      fetchReminders();
    }
  }, [investmentId, isOpen]);

  const handleReminderChange = (index, key, value) => {
    const updatedReminders = [...reminders];
    updatedReminders[index][key] = value;
    setReminders(updatedReminders);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Save reminders in a separate schema
    const remindersRef = doc(firestore, `investment_reminders/${investmentId}`);
    await setDoc(remindersRef, { reminders });

    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-8">
        <BlockTitle className="text-[22px]">
          Ustawienia przypomnień
        </BlockTitle>

        <form onSubmit={handleSave} className="grid grid-cols-2 gap-6 mt-6">

          {/* Reminder Settings */}
          <div className="col-span-2 mt-8">
            <div className="grid gap-6">
              {reminders.map((reminder, index) => (
                <div
                  key={index}
                  className="grid grid-cols-2 items-center gap-4"
                >
                  <div>
                    <FormLabel htmlFor={`days-${index}`}>
                      Dni po terminie
                    </FormLabel>
                    
                    <FormInput
                      type="number"
                      id={`days-${index}`}
                      value={reminder.days}
                      onChange={(e) =>
                        handleReminderChange(
                          index,
                          'days',
                          parseInt(e.target.value)
                        )
                      }
                      required
                    />
                  </div>
                  <div className="flex items-center mt-6">
                    <label className="form-switch">
                      <input
                        type="checkbox"
                        checked={reminder.enabled}
                        role="switch"
                        className="form-check-input form-check-input-sovo!"
                        onChange={(e) =>
                          handleReminderChange(index, 'enabled', e.target.checked)
                        }
                      />
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Buttons */}
          <div className="col-span-2 flex justify-end mt-10">
            <Button type="submit" variant="default">
              Zapisz
            </Button>
            <Button type="button" variant="bordered" onClick={onClose} className="ml-4">
              Anuluj
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditFlatReminderModal;
